import type { Template } from "@/types";

export const PO_02_H1_V1: Template[] = [
    {
        id: "po-02-h1v1-01",
        name: "PO 01 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 58, y: 233, width: 509, height: 319, rotation: 0, imageRotation: 0 },
            { id: "2", x: 784, y: 173, width: 312, height: 439, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-02",
        name: "PO 02 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 58, y: 233, width: 509, height: 319, rotation: 0, imageRotation: 0 },
            { id: "2", x: 734, y: 103, width: 409, height: 576, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-03",
        name: "PO 03 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 58, y: 233, width: 509, height: 319, rotation: 0, imageRotation: 0 },
            { id: "2", x: 626, y: 0, width: 626, height: 783, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-04",
        name: "PO 04 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 197, width: 626, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 662, y: 0, width: 554, height: 783, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-05",
        name: "PO 05 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 53, y: 125, width: 777, height: 528, rotation: 0, imageRotation: 0 },
            { id: "2", x: 837, y: 125, width: 362, height: 528, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-06",
        name: "PO 06 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 109, width: 857, height: 566, rotation: 0, imageRotation: 0 },
            { id: "2", x: 864, y: 109, width: 387, height: 565, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-07",
        name: "PO 07 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 108, y: 103, width: 409, height: 576, rotation: 0, imageRotation: 0 },
            { id: "2", x: 684, y: 233, width: 509, height: 319, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-08",
        name: "PO 08 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 626, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 684, y: 233, width: 509, height: 319, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-09",
        name: "PO 09 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 36, y: 0, width: 554, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 626, y: 197, width: 626, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-10",
        name: "PO 10- H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 157, y: 173, width: 312, height: 439, rotation: 0, imageRotation: 0 },
            { id: "2", x: 684, y: 233, width: 509, height: 319, rotation: 0, imageRotation: 0 }
        ],
    }
];